import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
ChartJS.register(ArcElement, Tooltip, Legend);

const ChartPricesCotizaciones = ({ userRedux }) => {


  useEffect(() => {
    fetchCostosPagado("");
      fetchCostosNoPagados("");
  }, []);
  // useEffect(() => {
  //   if (userRedux.puesto.toUpperCase() === "JEFE COMERCIAL" || userRedux?.puesto?.toUpperCase()==="JEFE DE PROYECTOS") {
  //     fetchCostosPagado("");
  //     fetchCostosNoPagados("");
  //   } else if (userRedux.puesto.toUpperCase() === "ASESOR DE VENTAS") {
  //     fetchCostosPagado("fuenteVentas=Comercial");
  //     fetchCostosNoPagados("fuenteVentas=Comercial");
  //   } else if (userRedux.puesto.toUpperCase() === "EJECUTIVO DE CUENTAS") {
  //     fetchCostosPagado("fuenteVentas=Agencia");
  //     fetchCostosNoPagados("fuenteVentas=Agencia");
  //   }
  // }, []);
  const tabs = [
    { id: 1, name: "Facturas", value: "Factura" },
    { id: 2, name: "Cotizaciones", value: "Cotizacion" },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  // useEffect(() => { 
  //   if (userRedux.puesto.toUpperCase() === "JEFE COMERCIAL" || userRedux?.puesto?.toUpperCase()==="JEFE DE PROYECTOS") {
  //     fetchFacturasOrCotizacionesData("");
  //   } else if (userRedux.puesto.toUpperCase() === "ASESOR DE VENTAS") {
  //     fetchFacturasOrCotizacionesData("fuenteVentas=Comercial");
  //   } else if (userRedux.puesto.toUpperCase() === "EJECUTIVO DE CUENTAS") {
  //     fetchFacturasOrCotizacionesData("fuenteVentas=Agencia");
  //   }
  // }, [activeTab]);

  useEffect(() => {
    fetchFacturasOrCotizacionesData("");

  }, [activeTab]);

  const [solesCostos, setSolesCostos] = useState({
    pagado: 0,
    noPagado: 0,
  });

  const [usdCostos, setUsdCostos] = useState({
    pagado: 0,
    noPagado: 0,
  });

  const fetchCostosPagado = async (query) => {
    if (userRedux) {
      try {
        const response = await axios.get(
          `${BACKEND}/api/totalAmountCotizacionesPrecio/getTotalAmount?pagado=true&${query}&`
        );

        setUsdCostos((prev) => ({ ...prev, pagado: response.data.sumUSD }));
        setSolesCostos((prev) => ({ ...prev, pagado: response.data.sumPEN }));
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fetchCostosNoPagados = async (query) => {
    if (userRedux) {
      try {
        const response = await axios.get(
          `${BACKEND}/api/totalAmountCotizacionesPrecio/getTotalAmount?pagado=${false}&${query}&`
        );

    
        setUsdCostos((prev) => ({ ...prev, noPagado: response.data.sumUSD }));
        setSolesCostos((prev) => ({ ...prev, noPagado: response.data.sumPEN }));
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fetchFacturasOrCotizacionesData = async (query) => {
    if (userRedux) {
      try {
        const response = await axios.get(
          `${BACKEND}/api/cotizacionFacturas/estadoFacturasCotizaciones?tipo=${activeTab.value}&${query}`
        );

        setCotOrFacturaData(response.data);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [cotOrFacturaData, setCotOrFacturaData] = useState(null);
  console.log(cotOrFacturaData);

  const dataSoles = {
    labels: [" Pagado", "Por pagar"],
    datasets: [
      {
        label: "S/",
        data: [solesCostos.pagado, solesCostos.noPagado],
        backgroundColor: ["rgba(255, 99, 132, 0.2)", "rgba(54, 162, 235, 0.2)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };
  const dataUSD = {
    labels: [" Pagado", "Por pagar"],
    datasets: [
      {
        label: "USD",
        data: [usdCostos.pagado, usdCostos.noPagado],
        backgroundColor: ["rgba(255, 99, 132, 0.2)", "rgba(54, 162, 235, 0.2)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className=" pb-12">
      <div className=" flex flex-col gap-6 md:grid md:grid-cols-12 max-w-5xl mx-auto">
        <div className=" mx-auto md:col-span-8  flex flex-col gap-10 md:grid md:grid-cols-2">
          <div>
            <div className=" max-w-xs mx-auto  bg-white shadow-md rounded-md p-4 md:mx-0 ">
              <div className=" pb-4">
                <h2 className=" text-center font-semibold text-gray-700">
                  Cuentas en Soles
                </h2>
              </div>
              <Pie className="" data={dataSoles} />
            </div>
          </div>
          <div>
          <div className=" max-w-xs mx-auto  bg-white shadow-md rounded-md p-4 md:mx-0 ">
            <div className=" pb-4">
              <h2 className=" text-center font-semibold text-gray-700">
                Cuentas en USD
              </h2>
            </div>
            <Pie className="" data={dataUSD} />
          </div>
          </div>
          
        </div>
        {cotOrFacturaData && (
          <div className=" md:col-span-4">
            <ul className="flex flex-wrap justify-center text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 ">
              {tabs.map((e) => (
                <li key={e.id} className="me-2">
                  <button
                    onClick={() => setActiveTab(e)}
                    type="button"
                    className={`inline-block p-4 ${
                      activeTab.id === e.id
                        ? "text-blue-600  bg-gray-200 "
                        : " text-gray-700 hover:bg-gray-50 "
                    }   rounded-t-lg active `}
                  >
                    {e.name}
                  </button>
                </li>
              ))}
            </ul>
            <div className="   rounded-md ">
              <div className="relative overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 ">
                    <tr>
                      <th scope="col" className="px-6 py-3"></th>
                      <th scope="col" className="px-6 py-3"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="bg-white border-b ">
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                      >
                        % {activeTab.name} Exito
                      </th>
                      <td className="px-6 py-4">
                        {(
                          (cotOrFacturaData.exito * 100) /
                          cotOrFacturaData.total
                        ).toFixed(1)}{" "}
                        %
                      </td>
                    </tr>
                    <tr className="bg-white border-b ">
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                      >
                        % {activeTab.name} Espera
                      </th>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {(
                          (cotOrFacturaData.enEspera * 100) /
                          cotOrFacturaData.total
                        ).toFixed(1)}{" "}
                        %
                      </td>
                    </tr>
                    <tr className="bg-white border-b ">
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                      >
                        % {activeTab.name} Perdidos
                      </th>
                      <td className="px-6 py-4  whitespace-nowrap">
                        {(
                          (cotOrFacturaData.perdidos * 100) /
                          cotOrFacturaData.total
                        ).toFixed(1)}{" "}
                        %
                      </td>
                    </tr>
                    <tr className="bg-white border-b ">
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                      >
                        N° {activeTab.name} Exito
                      </th>
                      <td className="px-6 py-4  whitespace-nowrap">
                        {cotOrFacturaData.exito}{" "}
                      </td>
                    </tr>
                    <tr className="bg-white border-b ">
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                      >
                        N° {activeTab.name} Espera
                      </th>
                      <td className="px-6 py-4  whitespace-nowrap">
                        {cotOrFacturaData.enEspera}{" "}
                      </td>
                    </tr>
                    <tr className="bg-white border-b ">
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                      >
                        N° {activeTab.name} Perdidos
                      </th>
                      <td className="px-6 py-4  whitespace-nowrap">
                        {cotOrFacturaData.perdidos}{" "}
                      </td>
                    </tr>
                    <tr className="bg-gray-50 border-b ">
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                      >
                        Total {activeTab.name}
                      </th>
                      <td className="px-6 py-4  whitespace-nowrap">
                        {cotOrFacturaData.total}{" "}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChartPricesCotizaciones;
